export const formatSpecificRange = (specificRangeString:string) => {
  const formattedSpecificRangeString = specificRangeString.replaceAll(/\s+/g, '')
    .replaceAll(/、|，/g, ',')
    .replaceAll(/－|―|ー/g, '-')
    .replaceAll(/[０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    })
  return formattedSpecificRangeString
}
